<template lang="pug">
  keep-alive
    div.group-name(v-if='loading')
      | Please wait
    div.group-name(v-else)
      el-form(
        v-if='myData'
        :model='myData'
        :ref='myData'
        @submit.native.prevent="validateForm('myData')"
      ).inline-split
        | {{ getTeamAndCategoryData() }}
        .row.row-xs
          div(v-if="fnIsValidCompanyUser(myData)").moved-transaction
            | This Transaction has been moved
          div(v-else).col-xl-3.col-lg-6.col-md-6.col-sm-6.col-12
            el-form-item(prop='Company')
              //- .col-sm-6.col-md-2
              el-select(
                v-model='myData.selectedCompany'
                placeholder='Company'
                v-on:change='handleCommand($event)'
                filterable
              )
                el-option(
                  v-for='item in me.parentChildCompany'
                  :key='item.id'
                  :label='item.companyName'
                  :value='item.id'
                )
          div(v-if="fnIsValidCompanyUser(myData)")
            |
          div(v-else).col-xl-3.col-lg-6.col-md-6.col-sm-6.col-12
            el-form-item(prop='teamId')
              //- .col-sm-6.col-md-2
              el-select(
                v-model='myData.teamId'
                placeholder='Team Name'
                v-on:change='updateCategory($event)'
                filterable
              )
                el-option(
                  v-for='item in listTeams'
                  v-if='item.recordStatus===1'
                  :key='item.id'
                  :label='item.groupName'
                  :value='item.id'
                )
          div(v-if="fnIsValidCompanyUser(myData)")
            |
          div(v-else).col-xl-3.col-lg-6.col-md-6.col-sm-6.col-12
            el-form-item(prop='categoryId')
              //- .col-sm-6.col-md-2.category-name
              el-select(
                ref='myData.categoryId'
                :key='myData.categoryId'
                :value-key='myData.categoryId'
                v-model='myData.categoryId'
                placeholder='Category Name'
                v-on:change='categoryValue($event)'
                filterable
              )
                el-option(
                  v-for='item in this.listCategory'
                  v-if='item.recordStatus !==1 '
                  :key='item.id'
                  :label='item.categoryName'
                  :value='item.id'
                )
          div.col-xl-3.col-lg-6.col-md-6.col-sm-6.col-12
            .padd-right
              el-form-item(prop='amount')
                //- .col-sm-6.col-md-2.amount
                el-input(
                  type='Number',
                  v-model="myData.amount"
                  auto-complete='off',
                  placeholder='Amount'
                  @input="validateTotalAmount"
                )
            div.f-right.delete-col
              el-form-item.mb-0
                el-tooltip(content='Delete' placement='top')
                  el-button(
                    :disabled='myData.isMainTransaction'
                    type='text'
                    icon='el-icon-delete'
                    @click='splitRemoveTransactions(myData)'
                  )

</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default ({
  name: 'InlineSplitTransaction',
  props: {
    index: {
      default: 0,
      type: Number,
    },
    refresh: {
      default: () => {},
      type: Object,
    },
    myData: {
      default: () => {},
      type: Object,
    },
    deleteData: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      itteraction: 0,
      listCategory: [],
      listTeams: [],
      rules: {
        // tobe implemented;
      },
    };
  },

  computed: {
    ...mapGetters('shared', ['loadingChild', 'loading']),
    ...mapGetters('users', ['me']),
    ...mapGetters('transactions', ['selectedTeams', 'categoryForGroupWithoutUser', 'myDeleteTransaction']),
  },
  watch: {

  },

  async mounted() {
    await this.getTeamAndCategory(this.myData);
  },

  beforeUpdate() {
    if (this.itteraction === 0) {
      this.getTeamAndCategory(this.myData);
    }
  },


  methods: {
    ...mapActions('transactions', [
      'getTeams',
      'getUserUnCategorized',
    ]),
    fnIsValidCompanyUser(value) {
      let flag = true;
      // if new split then return false
      if (value.id === '') {
        flag = false;
      }

      //  if Transaction belong cluster then show
      this.me.parentChildCompany.forEach((item) => {
        if (item.id === value.selectedCompany) {
          flag = false;
        }
      });
      return flag;
    },

    async getTeamAndCategory(value) {
      this.itteraction = 1;
      if (value) {
        if (value.selectedCompany) {
          await this.getTeams({ id: this.myData.selectedCompany });
          this.listTeams = [...this.selectedTeams];
          this.listCategory = [];
          if (value.teamId !== '' && value.teamId !== null) {
            const x = this.listTeams.filter(item => item.id === value.teamId);
            this.listCategory = x[0].categories;
          }
        }
      }
    },
    validateTotalAmount(value) {
      this.$emit('validateTotalAmount', value);
    },

    getTeamAndCategoryData() {
      if (this.itteraction === 0) {
        this.getTeamAndCategory(this.myData);
      }
    },
    categoryValue(value) {
      this.myData.categoryId = value;
    },
    async updateCategory(value) {
      this.myData.categoryId = null;
      if (value !== '' && value !== null) {
        const x = this.listTeams.filter(item => item.id === value);
        this.listCategory = [...x[0].categories];
      }
    },
    async handleCommand() {
      this.myData.teamId = null;
      this.myData.categoryId = null;
      await this.getTeams({ id: this.myData.selectedCompany });
      this.listTeams = [...this.selectedTeams];
    },
    splitTransactions() {
      this.$emit('splitTransactions');
    },
    splitRemoveTransactions(data) {
      // No Accounting system connected
      const transactionId = data.id;
      if (transactionId !== '') {
        this.deleteData.push({ id: transactionId });
        this.myDeleteTransaction.push({ id: transactionId});
      }
      this.$emit('splitRemoveTransactions', { remove: transactionId });
      this.itteraction = 0;
    },
  },
});
</script>
